const colors = [
  'bg-indigo-600', 'bg-violet-600', 'bg-cyan-600', 'bg-amber-600',
  'bg-pink-600', 'bg-emerald-600', 'bg-rose-600', 'bg-teal-600',
  'bg-orange-600', 'bg-sky-600',
];

export function avatarColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) | 0;
  return colors[Math.abs(hash) % colors.length];
}
